export default __webpack_public_path__ + "static/media/sb.09d1cdb9.webp";